<div class="footer">
  <global-footer-store-links [userLocationA3]="userLocationA3$ | async" />
  <pac-footer-social-network-links
    [socialNetworkLinks]="socialNetworkLinks$ | async"
  />
  <pac-footer-language-select />
  <ng-content select="[links]" />
</div>

<div class="placeholder"></div>
